<div class="w-100 h-100 map_screen_container">
    <div [ngClass]="{'adv-map-overflow-visible': renderTree || renderSchematic,
                     'adv-map-overflow-hidden': renderMap
                    }" class="advanced_map_container">
        <ng-container *ngIf="renderMap">
            <google-map *ngIf="defaultConfig.coordinates" class="advanced_map" height="100%" width="100%"
                [options]="mapOptions" [zoom]="defaultConfig.zoom"
                [center]="{lat: defaultConfig.coordinates.latitude!, lng: defaultConfig.coordinates.longitude!}"
                (idle)="onMapChange()" (zoomChanged)="onZoomChanged()" (mapInitialized)="onMapInitialized($event)">
            </google-map>
            <button *ngIf="fullStreetViewVisible" class="full-street-view-close-btn" (click)="closeFullStreetView()">
                <img height="20" width="20" src="../../../assets/icons/close.svg" />
            </button>
            <div class="custom-controls">
                <button 
                    [class.active]="currentMapType === 'hybrid'"
                    (click)="setMapType('hybrid')">
                    {{ 'ADVANCED_MAP.SATELLITE' | translate }}
                </button>

                <button 
                    [class.active]="currentMapType === 'roadmap'"
                    (click)="setMapType('roadmap')">
                    {{ 'ADVANCED_MAP.MAP' | translate }}
                </button>
            </div>
            <!-- <div class="street-view-fixed" [hidden]="!showStreetView">
                <div #streetViewContainer class="street-view-container"></div>
            </div> -->
            <button class="legend-btn map-icon" (click)="togglePopup()">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.79167 13.9583H16.875M9.79167 6.04167H16.875M6.45833 6.04167C6.45833 6.96214 5.71214 7.70833 4.79167 7.70833C3.87119 7.70833 3.125 6.96214 3.125 6.04167C3.125 5.12119 3.87119 4.375 4.79167 4.375C5.71214 4.375 6.45833 5.12119 6.45833 6.04167ZM6.45833 13.9583C6.45833 14.8788 5.71214 15.625 4.79167 15.625C3.87119 15.625 3.125 14.8788 3.125 13.9583C3.125 13.0378 3.87119 12.2917 4.79167 12.2917C5.71214 12.2917 6.45833 13.0378 6.45833 13.9583Z" stroke="#171717" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <div class="theme-button map-icon" (click)="toggleThemeMenu()">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5697 10.0007C17.5697 15.8188 11.3559 10.6536 9.99969 13.3704C9.15858 15.0553 12.3777 17.1615 9.99969 17.1615C5.81889 17.1615 2.42969 13.9555 2.42969 10.0007C2.42969 6.04585 5.81889 2.83984 9.99969 2.83984C14.1805 2.83984 17.5697 6.04585 17.5697 10.0007Z" stroke="#171717" stroke-width="1.25"/>
                    <path d="M9.5905 6.52255C9.5905 7.08752 9.1325 7.54552 8.56753 7.54552C8.00255 7.54552 7.54455 7.08752 7.54455 6.52255C7.54455 5.95757 8.00255 5.49957 8.56753 5.49957C9.1325 5.49957 9.5905 5.95757 9.5905 6.52255Z" stroke="#171717" stroke-width="1.25"/>
                    <path d="M7.13536 10.0007C7.13536 10.5656 6.67736 11.0236 6.11239 11.0236C5.54742 11.0236 5.08942 10.5656 5.08942 10.0007C5.08942 9.43568 5.54742 8.97768 6.11239 8.97768C6.67736 8.97768 7.13536 9.43568 7.13536 10.0007Z" stroke="#171717" stroke-width="1.25"/>
                    <path d="M13.6824 7.75011C13.6824 8.31509 13.2244 8.77309 12.6594 8.77309C12.0944 8.77309 11.6364 8.31509 11.6364 7.75011C11.6364 7.18514 12.0944 6.72714 12.6594 6.72714C13.2244 6.72714 13.6824 7.18514 13.6824 7.75011Z" stroke="#171717" stroke-width="1.25"/>
                </svg>

                <!-- <img src="../../../assets/icons/theme-icon.svg" alt="Theme icon" /> -->
            </div>
            <!-- Theme menu -->
            <ng-container *ngIf="themeMenuOpen" [ngTemplateOutlet]="themeMenuTemplate"></ng-container>
            <!-- Legend popup -->
            <ng-container *ngIf="showPopup" [ngTemplateOutlet]="assetPopup"></ng-container>
        </ng-container>
        <ng-container *ngIf="renderTree">
            <app-network-assets [defaultConfig]="defaultConfig"></app-network-assets>
        </ng-container>
        <ng-container *ngIf="renderSchematic">
            <app-map-substation-schema-diagram></app-map-substation-schema-diagram>
        </ng-container>

        <!-- Search -->
        <div class="search-wrapper" *ngIf="renderMap">
            <button *ngIf="searchIconVisible" class="search-btn d-flex justify-content-center align-items-center" (click)="openSearch()">
                <img height="20" width="20" src="../../../assets/icons/ng_v3/search-map.svg" />
            </button>
            <div *ngIf="searchOpened" class="map-search-bar d-flex align-items-center">
                <div class="search-type-dropdown d-flex align-items-center gap-3" (click)="onSearchType($event)">
                    <span>{{ searchTypeLabel | translate }}</span>
                    <img height="14" width="14" src="../../../assets/icons/arrow-down-small.svg"/>                
                </div>
                <div class="search-input d-flex align-items-center">
                    <img src="../../../assets/icons/ng_v3/search-black.svg"/>
                    <input *ngIf="!isLocation" [disabled]="searchType == advancedMapSearchType.None" [(ngModel)]="searchText" type="text" [placeholder]="'COMMON.SEARCH' | translate" (input)="filterStations()" (focus)="this.searchDropdownOptionsVisible = true"/>
                    <input
                        *ngIf="isLocation"
                        type="text"
                        [placeholder]="'COMMON.SEARCH' | translate"
                        [(ngModel)]="searchText"
                        #locationInput
                    />
                    <div *ngIf="searchDropdownOptionsVisible && stations.length != 0" class="search-options-container">
                        <div (click)="filterByObject(station)" class="search-option" *ngFor="let station of filteredStations | slice:0:5 ">
                            <span>{{ station.name }}</span>
                        </div>  
                    </div>
                    <button (click)="restoreDefaults(true)" class="close-btn">x</button>
                </div>
            </div>
        </div>

        <div *ngIf="!searchOpened && renderMap" class="filter-wrapper">
            <button class="filter-btn d-flex justify-content-center align-items-center" (click)="openFilter()">
                {{ 'COMMON.FILTER' | translate }} <img height="20" width="20" src="../../../assets/icons/map-filter.svg" />
            </button>
            <div *ngIf="searchOpened" class="map-search-bar d-flex align-items-center">
                <div class="search-type-dropdown d-flex align-items-center gap-3" (click)="onSearchType($event)">
                    <span>{{ searchTypeLabel | translate }}</span>
                    <img height="14" width="14" src="../../../assets/icons/arrow-down-small.svg"/>                
                </div>
                <div class="search-input d-flex align-items-center">
                    <img src="../../../assets/icons/ng_v3/search-black.svg"/>
                    <input *ngIf="!isLocation" [disabled]="searchType == advancedMapSearchType.None" [(ngModel)]="searchText" type="text" [placeholder]="'COMMON.SEARCH' | translate" (input)="filterStations()" (focus)="this.searchDropdownOptionsVisible = true"/>
                    <input
                        *ngIf="isLocation"
                        type="text"
                        [placeholder]="'COMMON.SEARCH' | translate"
                        [(ngModel)]="searchText"
                        #locationInput
                    />
                    <div *ngIf="searchDropdownOptionsVisible && stations.length != 0" class="search-options-container">
                        <div (click)="filterByObject(station)" class="search-option" *ngFor="let station of filteredStations | slice:0:5 ">
                            <span>{{ station.name }}</span>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <!-- <div *ngIf="renderMap && !isBatchObjects" class="search-filter-btns d-flex">
            <button [class.btn-active]="filterOpened" (click)="openFilter()">
                <span class="btn-content">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.70123 20.254V14.0015M5.70123 10.25V3.74707M11.9998 20.0038V12.7505M11.9998 8.99915V3.99707M18.2984 20.2536V16.002M18.2984 12.2508V3.74707M3.74609 13.7515H7.74982M9.99982 9.24902H13.9998M16.2498 15.752H20.2498"
                            [attr.stroke]="filterOpened ? 'var(--primary-color)' : '#171717'" stroke-opacity="0.9"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span>Filter</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z"
                            [attr.fill]="filterOpened ? 'var(--primary-color)' : '#171717'" />
                    </svg>
                </span>
            </button>
        </div> -->

        <!-- Switch buttons -->
        <div class="switch-buttons d-flex" [class.switch-buttons--schematic]="renderSchematic">
            <div class="adv-switch_buttons ms-0 w-auto">
                <app-adv-switch-buttons [initBtnClicked]="isOnMap ? 'map-btn' : 'tree-btn'" (buttonClicked)="switchButtonClicked($event)"
                    [isOnMap]="isOnMap"></app-adv-switch-buttons>
            </div>
            <button *ngIf="!renderSchematic" (click)="toggleAnalyticsTemplate()" [disabled]="!isOnMap">
                <span class="btn-content">
                    <span>{{'ADVANCED_MAP.ANALYTICS' | translate}}</span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.0013 2.29297C5.74411 2.29297 2.29297 5.74411 2.29297 10.0013C2.29297 14.2585 5.74411 17.7096 10.0013 17.7096C13.3576 17.7096 16.2128 15.5646 17.2711 12.5707M10.0013 2.29297C14.2585 2.29297 17.7096 5.74411 17.7096 10.0013C17.7096 10.9022 17.5551 11.7671 17.2711 12.5707M10.0013 2.29297V10.0013L17.2711 12.5707" stroke="#171717" stroke-width="1.5" stroke-linejoin="round"/>
                    </svg>
                </span>
            </button>
        </div>

        <!-- Filter -->
        <ng-container *ngIf="filterOpened" [ngTemplateOutlet]="filterTemplate"></ng-container>

        <!-- Search -->
        <ng-container *ngIf="searchTypeOpened" [ngTemplateOutlet]="searchTemplate"></ng-container>

        <!-- Analytics -->
        <ng-container *ngIf="analyticsOpened" [ngTemplateOutlet]="analyticsTemplate"></ng-container>

    </div>
</div>

<ng-template #assetPopup>
    <div class="popup-container">
       <div class="assets row">
            <div class="title col-2">
                <h4>{{ 'ADVANCED_MAP.LEGEND.ASSETS' | translate }}</h4>
            </div>
            <div class="content col-10">
                <div class="icons-row row mb-4">
                    <div class="icon col-6 d-flex align-items-center gap-3">
                        <div class="icon-wrapper">
                            <img height="20" width="20" src="../../../assets/icons/ng_v3/map-legend-ts.svg" />
                        </div>
                        <span>{{ 'DASHBOARD.ASSET_BREAKDOWN.TRANSMISSION_STATIONS' | translate }}</span>
                    </div>
                    <div class="icon col-6 d-flex align-items-center gap-3">
                        <div class="icon-wrapper">
                            <img height="20" width="20" src="../../../assets/icons/ng_v3/map-legend-is.svg" />
                        </div>
                        <span>{{ 'DASHBOARD.ASSET_BREAKDOWN.INJECTION_SUBSTATIONS' | translate }}</span>
                    </div>
                </div>
                <div class="icons-row row">
                    <div class="icon col-6 d-flex align-items-center gap-3">
                        <div class="icon-wrapper">
                            <img height="20" width="20" src="../../../assets/icons/ng_v3/map-legend-dt.svg" />
                        </div>
                        <span>{{ 'DASHBOARD.ASSET_BREAKDOWN.DISTRIBUTION_SUBSTATIONS' | translate }}</span>
                    </div>
                    <div class="icon col-6 d-flex align-items-center gap-3">
                        <div class="icon-wrapper">
                            <img height="20" width="20" src="../../../assets/icons/ng_v3/map-legend-bc.svg" />
                        </div>
                        <span>{{ 'DASHBOARD.ASSET_BREAKDOWN.BUILDING_CUSTOMER' | translate }}</span>
                    </div>
                </div>
            </div>
       </div>   
       <div class="poles row">
            <div class="title col-2">
                <h4>{{ 'ADVANCED_MAP.LEGEND.POLES' | translate }}</h4>
            </div>
            <div class="content col-10">
                <div class="icons-row d-flex gap-5">
                    <div class="icon d-flex align-items-center gap-3">
                        <input type="checkbox" class="legend-checkbox" [checked]="polesVisible['hv']" (change)="onPolesToggled('hv', $event)" />
                        <div class="color-dot hv">
                        </div>
                        <span>{{ 'DASHBOARD.ASSET_BREAKDOWN.HV_POLES' | translate }}</span>
                    </div>
                    <div class="icon d-flex align-items-center gap-3">
                        <input type="checkbox" class="legend-checkbox" [checked]="polesVisible['mv']" (change)="onPolesToggled('mv', $event)" />
                        <div class="color-dot mv">
                        </div>
                        <span>{{ 'DASHBOARD.ASSET_BREAKDOWN.MV_POLES' | translate }}</span>
                    </div>
                    <div class="icon d-flex align-items-center gap-3">
                        <input type="checkbox" class="legend-checkbox" [checked]="polesVisible['lv']" (change)="onPolesToggled('lv', $event)" />
                        <div class="color-dot lv">
                        </div>
                        <span>{{ 'DASHBOARD.ASSET_BREAKDOWN.LV_POLES' | translate }}</span>
                    </div>
                </div>
            </div>
       </div>
       <div class="lines row">
            <div class="title col-2">
                <h4>{{ 'ADVANCED_MAP.LEGEND.LINES' | translate }}</h4>
            </div>
            <div class="content col-10">
                <div class="icons-row d-flex gap-5">
                    <div class="icon d-flex align-items-center gap-3">
                        <input type="checkbox" class="legend-checkbox" [checked]="linesVisible['hv']" (change)="onLinesToggled('hv', $event)" />
                        <div class="color-line hv">
                        </div>
                        <span>{{ 'DASHBOARD.ASSET_BREAKDOWN.HV_POLES' | translate }}</span>
                    </div>
                    <div class="icon d-flex align-items-center gap-3">
                        <input type="checkbox" class="legend-checkbox" [checked]="linesVisible['mv']" (change)="onLinesToggled('mv', $event)" />
                        <div class="color-line mv">
                        </div>
                        <span>{{ 'DASHBOARD.ASSET_BREAKDOWN.MV_POLES' | translate }}</span>
                    </div>
                    <div class="icon d-flex align-items-center gap-3">
                        <input type="checkbox" class="legend-checkbox" [checked]="linesVisible['lv']" (change)="onLinesToggled('lv', $event)" />
                        <div class="color-line lv">
                        </div>
                        <span>{{ 'DASHBOARD.ASSET_BREAKDOWN.LV_POLES' | translate }}</span>
                    </div>
                </div>
            </div>
       </div>
    </div>
</ng-template>

<ng-template #themeMenuTemplate>
    <div class="theme-menu-container d-flex gap-4">
        <div *ngFor="let theme of themes" class="theme d-flex flex-column align-items-center justify-content-center">
            <div class="image-wrapper" [class.selected]="theme.key === selectedTheme.key" (click)="selectTheme(theme)">
                <img height="68" width="68" [src]="theme.image" />
            </div>
            <span>{{ theme.name }}</span>
        </div>
    </div>
</ng-template>

<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true" (hidden.bs.modal)="closeMapDetailsModal()">
    <div style="max-width: 70rem;" class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content modal-map-details">
            <app-dt-map-full-details *ngIf="this.selectedMapAssetType == 0 && dtMapDetails"
                [dt]="dtMapDetails" (closeClicked)="closeFullDetailsModal()">
            </app-dt-map-full-details>

            <app-bc-map-full-details *ngIf="this.selectedMapAssetType == 1 && buildingMapDetails"
                [building]="buildingMapDetails" (closeClicked)="closeFullDetailsModal()">
            </app-bc-map-full-details>

            <app-pole-map-full-details *ngIf="this.selectedMapAssetType == 2 && poleMapDetails"
                [pole]="poleMapDetails" (imageClicked)="openImageModal($event)">
            </app-pole-map-full-details>
        </div>
    </div>
</div>


<div class="modal fade" id="imageModal" tabindex="-1" aria-labelledby="imageModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content p-0">
            <div class="modal-body text-center p-0 m-0">
                <img *ngIf="selectedImageUrl" [src]="selectedImageUrl" class="img-fluid" alt="Full Image" />
            </div>
        </div>
    </div>
</div>

<!-- <div class="modal fade modal-right" id="filterSideview" tabindex="-1" role="dialog"
    aria-labelledby="filterSideviewTitle" aria-hidden="true">
    <div class="modal-dialog modal-filter" role="document">
        <div class="modal-content modal-filter-content">
            <app-advanced-map-filter [filter]="mapFilter" [appliedFilters]="appliedFilters"></app-advanced-map-filter>
        </div>
    </div>
</div> -->

<ng-template #filterTemplate>
    <div class="filter-container">
        <app-advanced-map-filter [filter]="mapFilter" [appliedFilters]="appliedFilters"
            (applyFilterClicked)="applyFilterClicked($event)"
            (closeFilterClicked)="closeFilterClicked($event)"></app-advanced-map-filter>
    </div>
</ng-template>
<ng-template #searchTemplate>
    <div class="search-container">
        <app-search-map-component (coordinates)="getCoordinatesFromSearch($event)"
            (closeSearchClicked)="closeSearchClicked($event)" (objectEmitter)="filterByObject($event)" (searchTypeSelected)="onSearchTypeSelected($event)"
            (cimSubstationTemplateSelected)="onCimTemplateSelected($event)"
            (cimAcLineTypeSelected)="onCimAcLineTypeSelected($event)">
        </app-search-map-component>
    </div>
</ng-template>
<ng-template #analyticsTemplate>
    <div class="analytics-container">
        <div class="analytics-header d-flex">
            <span>{{'ADVANCED_MAP.ANALYTICS' | translate}}</span>
            <button (click)="toggleAnalyticsTemplate()">x</button>
        </div>
        <div class="total-div">
            <p>{{'COMMON.TOTAL' | translate }}</p>
            <div class="total-num-icon d-flex gap-3 align-items-center">
                <span class="total">{{ totalValue | number }}</span>
                <img height="20" width="20" src="../../../assets/icons/ng_v3/arrow-down-map-analytics.svg" />
            </div>
        </div>
        <div class="analytics-circle">
            <app-doughnut-chart [data]="analyticsData" [title]="'COMMON.BUILDING.PLURAL'"
                [colors]="analyticsColors"></app-doughnut-chart>
            <div class="donut-center">
                <span class="center-text">
                    <p>{{'COMMON.TOTAL' | translate }}</p>
                    <span class="total">{{ totalValue | number }}</span>
                </span>
            </div>
        </div>
        <div class="analytics-body">            
            <div class="body-row d-flex">
                <div class="d-flex">
                    <div class="circle" [style.background-color]="analyticsCounts.customerAnalytics.color"></div>
                    <span>{{ 'COMMON.CUSTOMER.PLURAL' | translate }}</span>
                </div>
                <div *ngIf="analyticsCounts.customerAnalytics.count == null" class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <span *ngIf="analyticsCounts.customerAnalytics.count != null">{{ analyticsCounts.customerAnalytics.count
                    | number }}</span>
            </div>
            <div class="body-row d-flex">
                <div class="d-flex">
                    <div class="circle" [style.background-color]="analyticsCounts.buildingAnalytics.color"></div>
                    <span>{{ 'COMMON.BUILDING.PLURAL' | translate }}</span>
                </div>
                <div *ngIf="analyticsCounts.buildingAnalytics.count == null" class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <span *ngIf="analyticsCounts.buildingAnalytics.count != null">{{ analyticsCounts.buildingAnalytics.count
                    | number }}</span>
            </div>
            <div class="body-row d-flex">
                <div class="d-flex">
                    <div class="circle" [style.background-color]="analyticsCounts.poleAnalytics.color"></div>
                    <span>{{ 'COMMON.POLE.PLURAL' | translate }}</span>
                </div>
                <div *ngIf="analyticsCounts.poleAnalytics.count == null" class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <span *ngIf="analyticsCounts.poleAnalytics.count != null">{{ analyticsCounts.poleAnalytics.count |
                    number }}</span>
            </div>
            <div *ngIf="!hasCimDataIntegration" class="body-row d-flex">
                <div class="d-flex">
                    <div class="circle" [style.background-color]="analyticsCounts.dtAnalytics.color"></div>
                    <span>{{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.DISTRIBUTION_SUBSTATION' | translate }}</span>
                </div>
                <div *ngIf="analyticsCounts.dtAnalytics.count == null" class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <span *ngIf="analyticsCounts.dtAnalytics.count != null">{{ analyticsCounts.dtAnalytics.count | number
                    }}</span>
            </div>
            <div class="body-row d-flex">
                <div class="d-flex">
                    <div class="circle" [style.background-color]="analyticsCounts.feederAnalytics.color"></div>
                    <span>{{ 'ADVANCED_MAP.FEEDERS' | translate }}</span>
                </div>
                <div *ngIf="analyticsCounts.feederAnalytics.count == null" class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <span *ngIf="analyticsCounts.feederAnalytics.count != null">{{ analyticsCounts.feederAnalytics.count |
                    number }}</span>
            </div>
            <div *ngIf="!hasCimDataIntegration" class="body-row d-flex">
                <div class="d-flex">
                    <div class="circle" [style.background-color]="analyticsCounts.substationAnalytics.color"></div>
                    <span>{{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.INJECTION_SUBSTATION' | translate }}</span>
                </div>
                <div *ngIf="analyticsCounts.substationAnalytics.count == null" class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <span *ngIf="analyticsCounts.substationAnalytics.count != null">{{
                    analyticsCounts.substationAnalytics.count | number }}</span>
            </div>
            <div *ngIf="!hasCimDataIntegration" class="body-row d-flex">
                <div class="d-flex">
                    <div class="circle" [style.background-color]="analyticsCounts.tsAnalytics.color"></div>
                    <span>{{ 'ADVANCED_MAP.SEARCH_TYPE_OPTIONS.TRANSMISSION_STATION' | translate }}</span>
                </div>
                <div *ngIf="analyticsCounts.tsAnalytics.count == null" class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <span *ngIf="analyticsCounts.tsAnalytics.count != null">{{ analyticsCounts.tsAnalytics.count | number
                    }}</span>
            </div>
            <ng-container *ngIf="hasCimDataIntegration">
                <div *ngFor="let ss of analyticsCounts.cimSsCounts" class="body-row d-flex">
                    <div class="d-flex">
                        <div class="circle" [style.background-color]="ss.color"></div>
                        <span>{{ ss.name }}</span>
                    </div>
                    <span>{{ ss.count | number }}</span>
                </div>
            </ng-container>
            <div class="body-row d-flex">
                <div class="d-flex">
                    <div class="circle" [style.background-color]="analyticsCounts.deviceAnalytics.color"></div>
                    <span>{{ 'ADVANCED_MAP.EQUIPMENT' | translate }}</span>
                </div>
                <div *ngIf="analyticsCounts.deviceAnalytics.count == null" class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <span *ngIf="analyticsCounts.deviceAnalytics.count != null">{{ analyticsCounts.deviceAnalytics.count |
                    number }}</span>
            </div>
        </div>
    </div>
</ng-template>

<ng-container *ngIf="generatedObjectUrl">
    <app-generated-object-representation 
        #objectViewer
        [modelUrl]="generatedObjectUrl"
        (closeGeneratedObjectModal)="closeGeneratedModal()"
    >
    </app-generated-object-representation>
</ng-container>

<div class="modal fade" id="assetModalMap" tabindex="-1" aria-labelledby="assetModalMapLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="assetModalMapLabel">LV Poles Map</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <google-map
          #modalMap
          class="asset-modal-map"
          height="500px"
          width="100%"
          [options]="modalMapOptions"
          [zoom]="modalMapConfig.zoom"
          [center]="{
            lat: modalMapConfig.coordinates.latitude!,
            lng: modalMapConfig.coordinates.longitude!
          }"
        >
        </google-map>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [disabled]="!locationChanged && this.tempConnectionLines.length == 0 " (click)="onSaveClicked()" data-bs-dismiss="modal">Save</button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" [class.show]="pendingPoleId !== null" [style.display]="pendingPoleId !== null ? 'block' : 'none'" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0">
      <div class="modal-header border-0">
        <h5 class="modal-title">
          {{ confirmationMode === 'connect' ? 'Connect this pole?' : 'Remove connection?' }}
        </h5>
      </div>
      <div class="modal-footer border-0">
        <button class="btn btn-primary" (click)="confirmConnectOrRemove()">Yes</button>
        <button class="btn btn-secondary" (click)="cancelConnect()">No</button>
      </div>
    </div>
  </div>
</div>



